import { IPaymentTotals, IVatTotal } from "@prostocheck/shared";

import {
  readNumber,
  readPaymentMethod,
  readRows,
  readText,
  toMoney,
  VAT_TAX_TYPE,
} from "../document-xml";
import { PAY_FORMS_CONTAINER, TAXES_CONTAINER } from "./z-report-xml.constants";
import { IZReportSectionTotals } from "./z-report-xml.models";

const EMPTY_PAYMENTS: IPaymentTotals = { cash: 0, card: 0 };

const toPayments = (rows: Element[]): IPaymentTotals =>
  rows.reduce<IPaymentTotals>((totals, row) => {
    const method = readPaymentMethod(row);
    const sum = readNumber(row, "SUM");

    return { ...totals, [method]: toMoney(totals[method] + sum) };
  }, EMPTY_PAYMENTS);

const toVatTotals = (rows: Element[]): IVatTotal[] =>
  rows
    .filter(row => readText(row, "TYPE") === VAT_TAX_TYPE)
    .map(row => ({
      rate: readNumber(row, "PRC"),
      turnover: toMoney(
        readNumber(row, "TURNOVER") || readNumber(row, "SOURCESUM"),
      ),
      amount: toMoney(readNumber(row, "SUM")),
    }));

/** An absent `<ZREPRETURN>` means the shift had no returns, not missing data. */
export const readSectionTotals = (
  section: Element | null,
): IZReportSectionTotals => {
  if (!section) {
    return { sum: 0, ordersCount: 0, payments: EMPTY_PAYMENTS, vat: [] };
  }

  return {
    sum: toMoney(readNumber(section, "SUM")),
    ordersCount: readNumber(section, "ORDERSCNT"),
    payments: toPayments(readRows(section, PAY_FORMS_CONTAINER)),
    vat: toVatTotals(readRows(section, TAXES_CONTAINER)),
  };
};
